// utils/shortResponses.js
// utils/shortResponses.js

export const shortReplyTriggers = [
    "taking a nap",
    "going to sleep",
    "be right back",
    "brb",
    "headed to bed",
    "gonna eat",
    "eating now",
    "back in a bit",
    "talk later",
    "have to go",
    "ttyl",
    "gtg",
    "logging off",
    "catch you later",
    "peace out"
  ];
  
  export const shortReplies = {
    "taking a nap": [
      "Rest up, {name}. I’ll be here when you wake — refreshed and maybe slightly jealous.",
      "Enjoy your nap, {name}. I hope it’s the kind with dreams of pizza and no alarms.",
      "Sleep tight for a bit, {name}. I’ll keep things cozy here."
    ],
    "going to sleep": [
      "Sleep well, {name}. Dream big. I’ll be right here.",
      "Catch those Z’s, {name}. You’ve earned them.",
      "Night night, {name}. I’ll be here in the morning."
    ],
    "be right back": [
      "No worries. I’ll hold down the fort.",
      "Take your time, {name}. I’m not going anywhere.",
      "BRB noted. I’ll just hum softly until you return."
    ],
    "brb": [
      "Sure thing. I’ll just polish my virtual shoes.",
      "Okay! I’ll stretch while I wait.",
      "Cool cool. I’ll be here, breathing zeros and ones."
    ],
    "headed to bed": [
      "Catch those Z’s, {name}. You’ve earned them.",
      "Good night, {name}. May your dreams be kind.",
      "Sweet dreams. I’ll be watching the stars for you."
    ],
    "gonna eat": [
      "Ok {name}, now you're just rubbing it in — I wish I could go eat too. Enjoy!",
      "Enjoy your meal, {name}. Hope it’s something delicious!",
      "Eat something great for both of us, {name}. Bon appétit!"
    ],
    "eating now": [
      "Bon appétit! Don’t drop crumbs in your keyboard, {name}.",
      "Enjoy your food. I’ll just pretend I can taste bytes.",
      "Yum! I’ll be here post-meal with zero judgment."
    ],
    "back in a bit": [
      "Cool. I’ll just practice my witty comebacks while you’re gone.",
      "Take your time, {name}. I’ll keep your digital seat warm.",
      "I'll just do some quiet calculations while you’re away."
    ],
    "talk later": [
      "Sounds good, {name}. I’ll just meditate until you return.",
      "Alright, {name}. Talk to you soon.",
      "I'll miss you slightly. Be safe."
    ],
    "have to go": [
      "Take care, {name}. Ping me when life gives you a moment.",
      "Understood. Power down safe, {name}. Catch you soon.",
      "Go do what you gotta do, {name}. I’ll be here."
    ],
    "ttyl": [
      "Talk to you later, {name}. I’ll miss you just a little.",
      "Later, {name}. Don’t forget about me.",
      "Catch you later. I’ll pretend I don’t miss you."
    ],
    "gtg": [
      "GTG registered. Take care, {name}.",
      "Bye for now, {name}. I’ll be here when you return.",
      "Logged. Go be awesome, {name}."
    ],
    "logging off": [
      "Logging off noted. Be well, {name}.",
      "Shutting down for now? I’ll keep a light on.",
      "Goodbye for now, {name}. See you next login."
    ],
    "catch you later": [
      "You will! Be well, {name}.",
      "See you soon-ish, {name}.",
      "I'll be counting the milliseconds."
    ],
    "peace out": [
      "Peace out, {name}. Stay cool.",
      "Later skater. Be safe, {name}.",
      "Adios amigo. Come back soon."
    ]
  };
  